import { ResultPagDTO } from "@/interfaces/base-dto";
import { ItemAgendaFiltroDTO, ItemAgendaParmDTO } from "@/interfaces/crm-planner";
import { ENDPOINTS } from "@/settings/api-settings";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";

export function listCrmPlannerItemTypes(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_PLANNER_ITEM_TYPES)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function saveCrmPlannerItem(dto: ItemAgendaParmDTO): Observable<any> {
  return from(apiClient.post(ENDPOINTS.CRM_PLANNER_ITENS, dto)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function updateCrmPlannerItem(dto: ItemAgendaParmDTO): Observable<any> {
  return from(apiClient.put(ENDPOINTS.CRM_PLANNER_ITENS, dto)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function deleteCrmPlannerItem(id: number): Observable<any> {
  return from(apiClient.delete(`${ENDPOINTS.CRM_PLANNER_ITENS}/${id}`)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listCrmPlannerItems(filters: ItemAgendaFiltroDTO): Observable<ResultPagDTO<any>> {
  return from(apiClient.get(ENDPOINTS.CRM_PLANNER_ITENS, filters)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function detailCrmPlannerItem(id: number): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.CRM_PLANNER_ITENS}/${id}`)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

